import React from "react";
import { useTranslation } from "react-i18next";
import "./addons.css";

function EmptyCatering({ addDish }) {
  const { t } = useTranslation("addons");

  return (
    <div className="empty-addons">
      <div className="empty-addons-content">
        <img
          src="/Group.svg"
          alt={t("empty.altImage")}
          className="empty-addons__image"
        />
        <h2 className="empty-addons__title">
          {t("empty.title")}
        </h2>
        <p className="empty-addons__text">
          {t("empty.text")}
        </p>
        <button onClick={addDish} className="empty-addons__button">
          <img className="add-square-icon" src="/add.svg" alt="" />
          {t("empty.button")}
        </button>
        <button
          onClick={addDish}
          className="empty-addons__mobile-button"
        >
          <img className="add-square-icon" src="/add.svg" alt="" />
          {t("empty.button")}
        </button>
      </div>
    </div>
  );
}

export default EmptyCatering;
